export default {
  "mainVegetable": "podstawowe-warzywo",
  "mainVegetable/01": "podstawowe-warzywo/baklazan",
  "mainVegetable/02": "podstawowe-warzywo/szparagi",
  "mainVegetable/03": "podstawowe-warzywo/awokado",
  "mainVegetable/04": "podstawowe-warzywo/buraki",
  "mainVegetable/05": "podstawowe-warzywo/brokuly",
  "mainVegetable/06": "podstawowe-warzywo/marchewka",
  "mainVegetable/07": "podstawowe-warzywo/seler",
  "mainVegetable/08": "podstawowe-warzywo/pieczarki",
  "mainVegetable/09": "podstawowe-warzywo/kapusta",
  "mainVegetable/10": "podstawowe-warzywo/brukselka",
  "mainVegetable/11": "podstawowe-warzywo/kapusta-pekinska",
  "mainVegetable/12": "podstawowe-warzywo/kalafior",
  "mainVegetable/13": "podstawowe-warzywo/coleslaw",
  "mainVegetable/14": "podstawowe-warzywo/ogorki",
  "mainVegetable/15": "podstawowe-warzywo/cukinia",
  "mainVegetable/16": "podstawowe-warzywo/endywia",
  "mainVegetable/17": "podstawowe-warzywo/szpinak",
  "mainVegetable/18": "podstawowe-warzywo/bob",
  "mainVegetable/19": "podstawowe-warzywo/flazoletka",
  "mainVegetable/20": "podstawowe-warzywo/fasola-plaska",
  "mainVegetable/21": "podstawowe-warzywo/fasola-sucha",
  "mainVegetable/22": "podstawowe-warzywo/fasolka-szparagowa-zielona",
  "mainVegetable/23": "podstawowe-warzywo/soczewica",
  "mainVegetable/24": "podstawowe-warzywo/macedoine",
  "mainVegetable/25": "podstawowe-warzywo/kukurydza",
  "mainVegetable/26": "podstawowe-warzywo/mix-salat",
  "mainVegetable/27": "podstawowe-warzywo/rzepa",
  "mainVegetable/28": "podstawowe-warzywo/cebula",
  "mainVegetable/29": "podstawowe-warzywo/soja",
  "mainVegetable/30": "podstawowe-warzywo/papryka",
  "mainVegetable/31": "podstawowe-warzywo/ziemniaki",
  "mainVegetable/32": "podstawowe-warzywo/kielki-soi",
  "mainVegetable/33": "podstawowe-warzywo/rzodkiewka",
  "mainVegetable/34": "podstawowe-warzywo/salata-lisc-debu",
  "mainVegetable/35": "podstawowe-warzywo/salata-lodowa",
  "mainVegetable/36": "podstawowe-warzywo",
  "mainVegetable/37": "podstawowe-warzywo/salatka-piemoncka",
  "mainVegetable/38": "podstawowe-warzywo/salatki-z-ryzu",
  "mainVegetable/39": "podstawowe-warzywo/salata-rzymska",
  "mainVegetable/40": "podstawowe-warzywo/kielki",
  "mainVegetable/41": "podstawowe-warzywo/salata--",
  "mainVegetable/42": "podstawowe-warzywo/roszponka",
  "mainVegetable/43": "podstawowe-warzywo/rukola",
  "mainVegetable/44": "podstawowe-warzywo/salsefia",
  "mainVegetable/45": "podstawowe-warzywo/taboule",
  "mainVegetable/46": "podstawowe-warzywo/pomidory",
  "mainVegetable/47": "podstawowe-warzywo/fasola-biala",
  "mainVegetable/48": "podstawowe-warzywo/cieciorka",
  "mainVegetable/49": "podstawowe-warzywo/por",
  "mainVegetable/50": "podstawowe-warzywo/dynia",
  "mainVegetable/51": "podstawowe-warzywo/czerwona-fasola-Kidney",
  "mainVegetable/52": "podstawowe-warzywo/jablka",
  "mainVegetable/53": "podstawowe-warzywo/kasztany-jadalne",
  "mainVegetable/54": "podstawowe-warzywo/gruszki",
  "mainVegetable/55": "podstawowe-warzywo/ogrodnik",
  "mainVegetable/56": "podstawowe-warzywo/czarne-oliwki",
  "mainVegetable/57": "podstawowe-warzywo/karczochy",
  "mainVegetable/58": "podstawowe-warzywo/czerwona-papryka",
  "mainVegetable/59": "podstawowe-warzywo/fasola-zielona-plaska",
  "mainVegetable/60": "podstawowe-warzywo/wiosenny",
  "mainVegetable/61": "podstawowe-warzywo/ratatouille",
  "mainVegetable/62": "podstawowe-warzywo/kuskus",
  "mainVegetable/63": "podstawowe-warzywo/tagine",
  "mainVegetable/64": "podstawowe-warzywo/curry-z-warzywami",
  "mainVegetable/65": "podstawowe-warzywo/groszek-zielony",
  "mainVegetable/66": "podstawowe-warzywo",
  "mainVegetable/67": "podstawowe-warzywo/soczewica-koralowa",
  "mainVegetable/68": "podstawowe-warzywo/quinoa",
  "mainVegetable/69": "podstawowe-warzywo/orkisz",
  "mainVegetable/70": "podstawowe-warzywo/bulgur",
  "mainVegetable/71": "podstawowe-warzywo/czerwona-kapusta",
  "mainVegetable/72": "podstawowe-warzywo/jarmuz",
  "mainVegetable/73": "podstawowe-warzywo/trybula",
  "mainVegetable/74": "podstawowe-warzywo/ziarna-i-nasiona",
  "mainVegetable/75": "podstawowe-warzywo/warzywa-straczkowe",
  "mainVegetable/76": "podstawowe-warzywo/bataty",
  "mainVegetable/77": "podstawowe-warzywo/dynia",
  "mainVegetable/78": "podstawowe-warzywo/szczaw",
  "mainVegetable/79": "podstawowe-warzywo/fasola",
  "mainVegetable/80": "podstawowe-warzywo/groszek-z-marchewka",
  "mainVegetable/81": "podstawowe-warzywo/groszek--",
  "mainVegetable/82": "podstawowe-warzywo/fasola-edamame",
  "mainVegetable/83": "podstawowe-warzywo/kasza-jeczmienna",
  "mainVegetable/84": "podstawowe-warzywo/mix-do-salatki",
  "mainVegetable/85": "podstawowe-warzywo/cykoria-salatowa",
  "mainVegetable/86": "podstawowe-warzywo/salata-rzymska",
  "mainVegetable/87": "podstawowe-warzywo/szpinak-baby",
  "mainVegetable/88": "podstawowe-warzywo/salata-batawia",
  "mainVegetable/89": "podstawowe-warzywo/bietola",
  "mainVegetable/90": "podstawowe-warzywo/pasternak",
  "mainVegetable/91": "podstawowe-warzywo/ryz-czarny",
  "mainVegetable/92": "podstawowe-warzywo/mix-fasoli",
  "mainVegetable/93": "podstawowe-warzywo/czarna-fasola",
  "mainVegetable/94": "podstawowe-warzywo/kapusta-stozkowa",
  "mainVegetable/95": "podstawowe-warzywo/biala-fasola",
  "mainVegetable/96": "podstawowe-warzywo",
  "mainVegetable/97": "podstawowe-warzywo",
  "mainVegetable/98": "podstawowe-warzywo",
  "productRange": "zakresy",
  "productRange/4G_BIO": "zakresy",
  "productRange/4G_SRP": "zakresy",
  "productRange/CAN_A_POEL": "zakresy",
  "productRange/CAN_SEC_BI": "zakresy",
  "productRange/CAN_SEC_CO": "zakresy",
  "productRange/CAN_SEC_CU": "zakresy",
  "productRange/CAN_SEC_NA": "zakresy",
  "productRange/CAN_VAPEUR": "zakresy",
  "productRange/CAN_VEG_SA": "zakresy",
  "productRange/CAN_VEG_SR": "zakresy",
  "productRange/CLASSICVEG": "zakresy",
  "productRange/COLDVEGE": "zakresy",
  "productRange/COOKMUSH": "zakresy",
  "productRange/CRUDITES": "zakresy",
  "productRange/DE_NOS_PRO": "zakresy",
  "productRange/DOYMUSHACC": "zakresy",
  "productRange/DOYMUSHAPE": "zakresy",
  "productRange/DRYVEGE": "zakresy",
  "productRange/FROZENVEGE": "zakresy",
  "productRange/FRZ_ASTUCE": "zakresy",
  "productRange/FRZ_GRATIN": "zakresy",
  "productRange/FRZ_KELLO": "zakresy",
  "productRange/FRZ_LEG_CO": "zakresy",
  "productRange/FRZ_PUREES": "zakresy",
  "productRange/FRZ_VEG_BI": "zakresy",
  "productRange/FRZ_VEG_SR": "zakresy",
  "productRange/INDFROZVEG": "zakresy",
  "productRange/JEUNES_POU": "zakresy",
  "productRange/LAITUES": "zakresy",
  "productRange/LOOP": "zakresy",
  "productRange/LUNCH_BOWL": "zakresy",
  "productRange/MACHE_BASE": "zakresy",
  "productRange/MEL_LAITUE": "zakresy",
  "productRange/MUSHNATEMI": "zakresy",
  "productRange/MUSHNATENT": "zakresy",
  "productRange/MUSHNATEPA": "zakresy",
  "productRange/MUSHNATMIN": "zakresy",
  "productRange/MUSHROOMS": "zakresy",
  "productRange/SUNVEGE": "zakresy",
  "productRange/TRAIT_CRUD": "zakresy",
  "productRange/TRAIT_TABO": "zakresy",
  "productRange/TUS_RECETA": "zakresy",
  "productRange/WORLDVEGE": "zakresy",
  "productRange/PREPARED_VEG": "zakresy",
  "productRange/BEAN_SAUCE": "zakresy/fasole-w-sosie",
  "productRange/BEANS": "zakresy/fasola",
  "productRange/BIO": "zakresy/bio",
  "productRange/BOND_KIDS": "zakresy/bonduelki",
  "productRange/CAN_BIO": "zakresy",
  "productRange/CAN_SEC_PR": "zakresy",
  "productRange/CARTA_DELL": "zakresy",
  "productRange/CAN_PETITS": "zakresy",
  "productRange/CAN_BOCAL": "zakresy",
  "productRange/CEREAL_CAN": "zakresy/kaszetka-do-gotowania",
  "productRange/CEREAL_FRZ": "zakresy/kaszetka-mrozona",
  "productRange/CEREALI": "zakresy/kaszetka",
  "productRange/CEREALLEGR": "zakresy",
  "productRange/COCCOLE": "zakresy",
  "productRange/CORN": "zakresy/kukurydza",
  "productRange/CREATIF": "zakresy",
  "productRange/FRANCAIS": "zakresy",
  "productRange/FRZ_FRY_MI": "zakresy",
  "productRange/FRZ_MELANG": "zakresy",
  "productRange/FRZ_POELEE": "zakresy",
  "productRange/INSALATE_D": "zakresy",
  "productRange/INSALATONA": "zakresy",
  "productRange/LE_REGIONA": "zakresy",
  "productRange/LEGUMIO": "zakresy/warzywio",
  "productRange/MIXES_CORN": "zakresy/miksy-z-kukurydza",
  "productRange/MONO_VEGE": "zakresy/warzywa-mono",
  "productRange/MUSHROOMS  ": "zakresy/pieczarki",
  "productRange/NATURA_IN": "zakresy",
  "productRange/OTHER_VEG": "zakresy/inne-warzywa",
  "productRange/PEAS": "zakresy/groszek",
  "productRange/READY_FROZ": "zakresy",
  "productRange/SOUPS": "zakresy/soups",
  "productRange/SPINACH": "zakresy/szpinak",
  "productRange/STEAM_CAN": "zakresy/ugotowane-na-parze",
  "productRange/STEAM_FRZ": "zakresy/juz-przygotowane-na-parze",
  "productRange/STEAM_MIX": "zakresy",
  "productRange/STUZZICHIA": "zakresy",
  "productRange/TOUCHE": "zakresy/porcja-na-raz-na-twoja-salatke",
  "productRange/TRAIT_SAL": "zakresy",
  "productRange/TUS_RECETA ": "zakresy",
  "productRange/VEG_TO_FRY": "zakresy/mieszanki-na-patelnie",
  "productRange/VEGGIE": "zakresy/ryz-w-100-z-warzyw",
  "productRange/FRZ_JUSTEA": "zakresy",
  "productRange/SALABIS": "zakresy",
  "productRange/BON_SENGAG": "zakresy",
  "productRange/CROUSTIS": "zakresy",
  "season": "sezon",
  "season/1": "sezon/lato",
  "season/2": "sezon/jesien",
  "season/3": "sezon/zima",
  "season/4": "sezon/wiosna",
  "season/5": "sezon",
  "technologie": "technologia",
  "technologie/AC01": "technologia/konserwowe",
  "technologie/AD01": "technologia/mrozone",
  "technologie/AG01": "technologia/swieze",
  "technologie/AT01": "technologia/dania-gotowe",
  "recipeDish": "rodzaj-dania",
  "recipeDish/ACC": "rodzaj-dania/dodatek",
  "recipeDish/APE": "rodzaj-dania/aperitif",
  "recipeDish/DES": "rodzaj-dania/deser",
  "recipeDish/ENT": "rodzaj-dania/przystawka",
  "recipeDish/PLAT": "rodzaj-dania/danie-glowne",
  "recipeDish/SAL": "rodzaj-dania/salata",
  "recipeDish/SNA": "rodzaj-dania/przekaski",
  "recipeDish/PDE": "rodzaj-dania/sniadanie",
  "recipeDish/DEJ": "rodzaj-dania/obiad",
  "recipeDish/TRA": "rodzaj-dania/tradycyjne",
  "recipeDish/GOU": "rodzaj-dania/smakowite",
  "recipeDish/ETH": "rodzaj-dania/regionalne",
  "recipeDish/FCH": "rodzaj-dania/dla-dzieci",
  "recipeDish/SOU": "rodzaj-dania/zupa",
  "pred-recipeTimingCook-facet": "gotowanie-pieczenie",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "gotowanie-pieczenie/0-15-minut",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "gotowanie-pieczenie/15-30-minut",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "gotowanie-pieczenie/30-45-minut",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "gotowanie-pieczenie/45-minut",
  "pred-recipeTimingPreparation-facet": "przygotowanie",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "przygotowanie/0-15-minut",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "przygotowanie/15-30-minut",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "przygotowanie/30-45-minut",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "przygotowanie/45-minut",
  "pred-recipeCost-Facet": "koszt",
  "pred-recipeCost-Facet/petit": "koszt/tanie",
  "pred-recipeCost-Facet/moyen": "koszt/sredni",
  "pred-recipeCost-Facet/grand": "koszt/wysoki",
  "recipeDifficulty": "przygotowanie",
  "recipeDifficulty/1": "przygotowanie/latwe",
  "recipeDifficulty/2": "przygotowanie/srednie",
  "recipeDifficulty/3": "przygotowanie/trudne",
  "recipeDishNumber": "goscie",
  "recipeDishNumber/1": "goscie/1",
  "recipeDishNumber/2": "goscie/2",
  "recipeDishNumber/3": "goscie/3",
  "recipeDishNumber/4": "goscie/4",
  "recipeDishNumber/5": "goscie/5",
  "recipeDishNumber/6": "goscie/6",
  "recipeDishNumber/7": "goscie/7",
  "recipeDishNumber/8": "goscie/8",
  "productTheme": "produkty-wedlug-tematu",
  "productTheme/ACC": "produkty-wedlug-tematu/dodatek",
  "productTheme/BEA": "produkty-wedlug-tematu/fasola",
  "productTheme/BIS": "produkty-wedlug-tematu/fasola-w-sosie",
  "productTheme/BIO": "produkty-wedlug-tematu/bio",
  "productTheme/CAN": "produkty-wedlug-tematu/warzywa-w-puszce",
  "productTheme/CER": "produkty-wedlug-tematu",
  "productTheme/CLS": "produkty-wedlug-tematu/klasyczne",
  "productTheme/DLE": "produkty-wedlug-tematu/warzywa",
  "productTheme/EDR": "produkty-wedlug-tematu/wzbogacenie-posilku",
  "productTheme/ENT": "produkty-wedlug-tematu/przystawka",
  "productTheme/FRZ": "produkty-wedlug-tematu/mrozonki",
  "productTheme/FSD": "produkty-wedlug-tematu/do-salatki",
  "productTheme/FSH": "produkty-wedlug-tematu/swieze",
  "productTheme/ING": "produkty-wedlug-tematu/skladniki-do-moich-przepisow",
  "productTheme/JAR": "produkty-wedlug-tematu/warzywa-w-sloiku",
  "productTheme/LBW": "produkty-wedlug-tematu/good-lunch",
  "productTheme/LDF": "produkty-wedlug-tematu/warzywa-do-piekarnika",
  "productTheme/LEG": "produkty-wedlug-tematu/warzywa-straczkowe",
  "productTheme/LGO": "produkty-wedlug-tematu/warzywio",
  "productTheme/LGR": "produkty-wedlug-tematu/warzywa-grillowane",
  "productTheme/LGS": "produkty-wedlug-tematu",
  "productTheme/MAI": "produkty-wedlug-tematu/kukurydza",
  "productTheme/MUS": "produkty-wedlug-tematu/pieczarki",
  "productTheme/NEW": "produkty-wedlug-tematu/nowe-produkty",
  "productTheme/PDH": "produkty-wedlug-tematu/dania-gotowe-z-warzyw-straczkowych",
  "productTheme/PDL": "produkty-wedlug-tematu/kosz-warzyw",
  "productTheme/PHR": "produkty-wedlug-tematu/warzywa-w-formie-makaronu-i-ryzu",
  "productTheme/PLP": "produkty-wedlug-tematu/danie-glowne",
  "productTheme/RAL": "produkty-wedlug-tematu/ryz-z-warzyw",
  "productTheme/RDM": "produkty-wedlug-tematu/dania-gotowe",
  "productTheme/SAL": "produkty-wedlug-tematu/wszystko-do-mojej-salatki",
  "productTheme/SDB": "produkty-wedlug-tematu/salad-bowls",
  "productTheme/SNK": "produkty-wedlug-tematu/przekaska",
  "productTheme/SUP": "produkty-wedlug-tematu/zupa",
  "productTheme/TEX": "produkty-wedlug-tematu/tex-mex",
  "productTheme/VGP": "produkty-wedlug-tematu/bialko-roslinne",
  "recipeTheme": "przepisy-wedlug-tematu",
  "recipeTheme/01": "przepisy-wedlug-tematu/przepisy-letnie",
  "recipeTheme/02": "przepisy-wedlug-tematu/aperitif",
  "recipeTheme/03": "przepisy-wedlug-tematu/salatki-i-przekaski",
  "recipeTheme/04": "przepisy-wedlug-tematu/zupy-i-gaspacho",
  "recipeTheme/05": "przepisy-wedlug-tematu/quiche-tarty-i-zapiekanki",
  "recipeTheme/06": "przepisy-wedlug-tematu/specjaly-dla-dzieci",
  "recipeTheme/07": "przepisy-wedlug-tematu/desery",
  "recipeTheme/08": "przepisy-wedlug-tematu/wegetarianskie",
  "recipeTheme/09": "przepisy-wedlug-tematu/dodatki",
  "recipeTheme/10": "przepisy-wedlug-tematu/z-dalekich-stron",
  "recipeTheme/11": "przepisy-wedlug-tematu/wolno-gotowane",
  "recipeTheme/12": "przepisy-wedlug-tematu/salatki-i-barbecue",
  "recipeTheme/13": "przepisy-wedlug-tematu/przekaski-i-zakaski",
  "recipeTheme/14": "przepisy-wedlug-tematu/danie-glowne",
  "recipeTheme/15": "przepisy-wedlug-tematu/desery-i-ciastka",
  "recipeTheme/16": "przepisy-wedlug-tematu/przystawki-i-zupy",
  "recipeTheme/17": "przepisy-wedlug-tematu/salatki",
  "recipeTheme/18": "przepisy-wedlug-tematu/misy",
  "recipeTheme/19": "przepisy-wedlug-tematu/zupy-i-gaspacho",
  "recipeTheme/20": "przepisy-wedlug-tematu/przekaski",
  "recipeTheme/21": "przepisy-wedlug-tematu/sos",
  "recipeTheme/22": "przepisy-wedlug-tematu/dania-jednogarnkowe",
  "recipeTheme/23": "przepisy-wedlug-tematu/inne-dania",
  "recipeTheme/24": "przepisy-wedlug-tematu/dania-do-piekarnika",
  "recipeTheme/25": "przepisy-wedlug-tematu",
  "recipeTheme/26": "przepisy-wedlug-tematu",
  "recipeTheme/27": "przepisy-wedlug-tematu",
  "recipeTheme/28": "przepisy-wedlug-tematu",
  "recipeTheme/33": "przepisy-wedlug-tematu",
  "recipeTheme/34": "przepisy-wedlug-tematu",
  "recipeTheme/35": "przepisy-wedlug-tematu",
  "recipeTheme/36": "przepisy-wedlug-tematu",
  "recipeTheme/37": "przepisy-wedlug-tematu",
  "recipeTheme/38": "przepisy-wedlug-tematu",
  "recipeTheme/39": "przepisy-wedlug-tematu",
  "recipeTheme/40": "przepisy-wedlug-tematu",
  "recipeTheme/41": "przepisy-wedlug-tematu",
  "recipeTheme/42": "przepisy-wedlug-tematu",
  "recipeTheme/43": "przepisy-wedlug-tematu",
  "recipeTheme/44": "przepisy-wedlug-tematu",
  "recipeTheme/45": "przepisy-wedlug-tematu",
  "recipeTheme/46": "przepisy-wedlug-tematu",
  "pred-particularite": "zwyczaje-zywieniowe",
  "pred-particularite/Sans%20conservateur": "zwyczaje-zywieniowe/bez-konserwantow",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "zwyczaje-zywieniowe",
  "pred-particularite/Sans%20colorant": "zwyczaje-zywieniowe/bez-sztucznych-barwnikow",
  "pred-particularite/Sans%20sucre%20ajout%E9": "zwyczaje-zywieniowe/bez-dodanego-cukru",
  "pred-particularite/Sans%20sel%20ajout%E9": "zwyczaje-zywieniowe/bez-dodanej-soli",
  "pred-particularite/Sans%20additif": "zwyczaje-zywieniowe/bez-dodatkow",
  "pred-particularite/": "zwyczaje-zywieniowe/naturalnie-wystepujaca-sol",
  "pred-particularite/Sans%20lactose": "zwyczaje-zywieniowe/bez-laktozy",
  "pred-particularite/Sans%20gluten": "zwyczaje-zywieniowe/bez-glutenu",
  "pred-particularite/V%E9g%E9tarien": "zwyczaje-zywieniowe/wegetarianskie",
  "pred-particularite/V%E9g%E9talien": "zwyczaje-zywieniowe/weganskie",
  "pred-particularite/Sans%20sulfite": "zwyczaje-zywieniowe",
  "pred-particularite/A%20la%20vapeur": "zwyczaje-zywieniowe",
  "pred-particularite/Sans%20condiment": "zwyczaje-zywieniowe",
  "cultureType": "rodzaj-uprawy",
  "cultureType/Bio": "rodzaj-uprawy/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "rodzaj-uprawy/bez-pozostalosci-pestycydow",
  "cultureType/Sans%20OGM": "rodzaj-uprawy/bez-gmo",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "zwyczaje-zywieniowe/wegetarianskie",
  "pred-particularite/recipeVeggie": "zwyczaje-zywieniowe/weganskie",
  "pred-particularite/recipeGlutenfree": "zwyczaje-zywieniowe/bez-glutenu",
  "pred-particularite/recipeLactosefree": "zwyczaje-zywieniowe/bez-laktozy"
};
